














































import { Component, Prop, Vue } from 'vue-property-decorator'

import { Team } from '@/types/match'
import { mapState } from 'vuex'

import TeamPenalties from './TeamPenalties.vue'

@Component({
  components: {
    TeamPenalties,
  },

  computed: {
    ...mapState('match', ['controlsLocked']), // map state-properties from 'match'-module
  },
})
export default class TeamView extends Vue {
  @Prop() readonly team!: Team
  @Prop() readonly teamShort!: 'h' | 'v'
}
